'use strict'

module.exports = function sortnodes(wrapper, itemSelector, onStart, onUpdate) {
	var dragEl
	var from
	var to

	[].slice.call(wrapper.children).forEach(itemEl => {
		itemEl.draggable = true
	})

	function _onDragOver(event) {

		event.preventDefault()
		event.dataTransfer.dropEffect = 'move'

		var target = event.target
		if (!target.classList.contains(itemSelector)) {
			target = target.closest(itemSelector)
		}

		if (target && target !== dragEl) {
			wrapper.insertBefore(dragEl,
				nodeIndex(target) > nodeIndex(dragEl) ? target.nextElementSibling : target)
		}
	}


	function nodeIndex(child) {
		if (!child) { return -1 }
		let parent = child.parentNode
		var index = -1
		parent.querySelectorAll(itemSelector).forEach((el, i) => {
			if (el === child) { index = i }
		})
		return index
	}

	function _onDragEnd(event) {
		event.preventDefault()
		to = nodeIndex(dragEl)

		wrapper.removeEventListener('dragover', _onDragOver, false)
		wrapper.removeEventListener('dragend', _onDragEnd, false)
		dragEl.classList.remove('edit-tools-drag-ghost')

		onUpdate(dragEl, from, to)
	}

	function _onDragStart(event) {
		onStart()
		dragEl = event.target
		if (!dragEl.classList.contains(itemSelector)) {
			dragEl = dragEl.closest(itemSelector)
		}
		from = nodeIndex(dragEl)
		event.dataTransfer.effectAllowed = 'move'
		event.dataTransfer.setData('Text', dragEl.textContent)

		wrapper.addEventListener('dragover', _onDragOver, false)
		wrapper.addEventListener('dragend', _onDragEnd, false)

		setTimeout(() => {
			dragEl.classList.add('edit-tools-drag-ghost')
		}, 0)
	}

	wrapper.addEventListener('dragstart', _onDragStart, false)

	function end() {
		wrapper.removeEventListener('dragstart', _onDragStart, false)
	}

	return end

}



//////////////////
// WEBPACK FOOTER
// ./src/helpers/sortnodes.js
// module id = 6
// module chunks = 0